export var classListSupport = 'classList' in document.createElement('_');


//////////////////
// WEBPACK FOOTER
// /Users/martin/Sites/turnbull-cms/site/web/app/themes/sage/node_modules/tiny-slider/src/helpers/classListSupport.js
// module id = 32
// module chunks = 0